<template>
    <footer class="footer">
        hxboy.com 备案号：<a href="https://beian.miit.gov.cn/" target="_blank">京ICP备19027609号</a>
    </footer>
</template>

<script>
export default {
    name: 'Header',
    components: {
    }
}
</script>
<style lang="scss" scoped>
    .footer{
        width: 100%;
        height: 100px;
        text-align: center;
        line-height: 100px;
        background-color: #333;
        color: #fff;
        a{
            color: #fafafa;
            &:hover{
                color: #ff6900;
            }
        }
    }
</style>



// WEBPACK FOOTER //
// src/views/_common/Footer/index.vue